import { WireFieldsComponent } from "common/wire";
import { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import "twin.macro";

export const Fields: WireRenderer<WireFieldsComponent> = props => {
    return (
        <div tw="text-base py-5 px-8 bg-bg-front shadow-md-dark rounded-lg last:rounded-b-none">
            <h2 tw="text-2xl text-text-dark font-bold mb-4">{props.title}</h2>
            <ul
                tw="list-none grid grid-cols-1 gap-3
                    gp-md:grid-cols-2
                    gp-lg:grid-cols-2
                    gp-xl:grid-cols-3
                    gp-2xl:grid-cols-4">
                {props.fields.map(f => {
                    return (
                        <li>
                            <div tw="mb-1 text-text-xpale whitespace-pre-wrap break-words">{f.name}</div>
                            <div tw="whitespace-pre-wrap break-words">{f.value}</div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
